<template>
  <div class="login-container">
    <div v-if="loading" class="loading-overlay">
      <img class="loading-spinner" src="../assets/logo.png" alt="loading" />
    </div>
    <h2>Login</h2>
    <form @submit.prevent="handleLogin">
      <div>
        <label for="username">Username</label>
        <input autocomplete="username" type="text" v-model="username" id="username" required :disabled="loading"/>
      </div>
      <div>
        <label for="password">Password</label>
        <input autocomplete="password" type="password" v-model="password" id="password" required :disabled="loading"/>
      </div>
      <div>
        <button type="submit" :disabled="loading">
          <span v-if="loading">Logging in...</span>
          <span v-else>Login</span>
        </button>
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </form>
  </div>
</template>

<script>
import authService from "@/services/authService";
import { useRouter } from "vue-router";

export default {
  data() {
    return {
      username: "",
      password: "",
      errorMessage: null,
      loading: false
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  async mounted() {
    const check = await authService.checkAuth();
    if (check.success) {
      await this.router.push("/admin");
    }
  },
  methods: {
    async handleLogin() {
      this.errorMessage = null;
      this.loading = true;
      try {
        const response = await authService.login(this.username, this.password);
        if (response.success) {
          await this.router.push("/admin");
        } else {
          this.errorMessage = "Invalid username or password.";
        }
      } catch (error) {
        this.errorMessage = "An error occurred during login.";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  margin: 50px auto;
  width: 300px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  position: relative;
}

label {
  display: block;
  margin-bottom: 8px;
}

input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

button:hover:enabled {
  background-color: #45a049;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: small;
  text-align: center;
}

.loading-overlay {
  border-radius: inherit;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999999 !important;
}

.loading-spinner {
  border-radius: 4px;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
